module.exports = __webpack_public_path__ + "static/media/hiba.380345ab.png";